import { useQuery } from "@tanstack/react-query";

import { IStudy } from "../../../@types/admin/AdminStudy";
import { IPaginatedResponse } from "../../../@types/PaginatedResponse";
import { studiesService } from "../../../services/admin";
import { ensureOk } from "../../../utils/ensureOk";

export function useStudies() {
  const { data, isLoading, isError } = useQuery<IPaginatedResponse<IStudy[]>>({
    queryKey: ["admin-studies"],
    queryFn: async () => ensureOk(await studiesService.getStudies()),
    // No manual Refresh button on migrated admin pages (EN-5129 UI feedback),
    // and the global QueryClient disables refetch-on-mount with a 3-minute
    // staleTime — so re-opening the page must re-read the list.
    refetchOnMount: "always",
  });

  return { studies: data?.result ?? [], isLoading, isError };
}
